import { useDispatch } from 'react-redux';
import GlobalTable from '../../../../components/CustomTableWithPagination/GlobalTable';
import GlobalWrapper from '../../../../components/Wrapper/GlobalWrapper';
import { useCallback, useEffect, useMemo, useState } from 'react';
import { isSameUserType } from '../../../../utils/helperFunction';
import { getCroList } from '../../../../redux/features/crmSlice';
import { crmTypes } from '../../../../utils/employeeTypes';
import { getCROlistUnderProject } from '../../../../redux/features/CRDslice';
import { FOUNDATION_DEPARTMENT_ID } from '../../../../utils/constants/departmentDetails';
import Autocomplete from '@mui/material/Autocomplete';
import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import TextField from '@mui/material/TextField';
import { useSelector } from 'react-redux';
import dayjs from 'dayjs';
import { studentClassRestartDateHeaderFn } from './utils/studentClassRestartDateTableHead';
import FromAndToDatePicker from '../../../../components/mui/FromAndToDatePicker';
import { getStudentClassRestartDateTable } from '../../../../redux/features/crdMigrationSlice';
import GlobalDialog from '../../../../components/mui/Dialogue/GlobalDialog';
import StudentProfileView from './components/StudentProfileView';

export default function StudentClassRestartDate() {
  // normal variable
  const dispatch = useDispatch();

  /***********************************************/
  // redux state

  const croList = useSelector((state) => state.crm.croList);
  const crosunderproject = useSelector((state) => state.crd?.crosunderproject);

  const studentClassRestartDateTable = useSelector((state) => state.crdMigration.studentClassRestartDateTable.data);
  const loading = useSelector((state) => state.crdMigration.studentClassRestartDateTable.loading);

  const meta = useSelector((state) => state.crdMigration.studentClassRestartDateTable.meta);
  /***********************************************/

  // react state
  const [cro, setCro] = useState(null);
  const [modalState, setModalState] = useState({
    actionKey: '',
    row: null,
  });
  const [fromDate, setFromDate] = useState(dayjs().startOf('month').format('YYYY-MM-DD'));
  const [toDate, setToDate] = useState(dayjs().endOf('month').format('YYYY-MM-DD'));

  const [tableState, setTableState] = useState({
    page: 1,
    pageSize: 50,
    search: '',
    sort: { field: '', direction: 'asc' },
    frozenColumns: [],
    hiddenColumns: [],
  });
  /***********************************************/

  // dispatch Params
  const dispatchParams = useMemo(
    () => ({
      page: tableState?.page,
      limit: tableState?.pageSize,
      search: tableState?.search,
      cro_id: cro?.userID ?? cro,
      fromDate,
      toDate,
      sortBy: tableState?.sort?.field,
      sortOrder: tableState?.sort?.direction,
    }),
    [tableState?.page, tableState?.search, tableState?.sort, tableState?.pageSize, cro, fromDate, toDate],
  );

  /***********************************************/

  // ----- Memozisation and use clall back

  const modalConfigs = useMemo(
    () => [
      {
        actionKey: 'student profile',
        title: 'Student Profile View',
        maxWidth: 'md',
        render: ({ row }) => <StudentProfileView id={row?.course_enrollment_id} />,
      },
    ],
    [],
  );

  const handleButtonActionClick = useCallback((actionKey, row, actionType) => {
    if (!actionKey || !row) return;
    else {
      setModalState({
        actionKey,
        row,
      });
    }
  }, []);

  const activeConfig = useMemo(() => {
    if (!Array.isArray(modalConfigs) || !modalState.actionKey || !modalState.row) return null;
    return modalConfigs.find((c) => c?.actionKey === modalState.actionKey) || null;
  }, [modalConfigs, modalState.actionKey, modalState.row]);

  const isCrm = useMemo(() => {
    const profile = JSON.parse(localStorage.getItem('cred')).profile;
    return isSameUserType({ roleArray: crmTypes, role: profile?.role });
  }, []);

  const studentClassRestartDateHeader = useMemo(() => studentClassRestartDateHeaderFn(), []);

  // mounting Fetch
  // ----- fetch common without dependancy

  useEffect(() => {
    dispatch(isCrm ? getCroList({ search: '' }) : getCROlistUnderProject(FOUNDATION_DEPARTMENT_ID));
  }, [dispatch, isCrm]);

  useEffect(() => {
    dispatch(getStudentClassRestartDateTable(dispatchParams));
  }, [dispatch, dispatchParams]);

  /***********************************************/

  return (
    <GlobalWrapper title={'Students Class Restart Date'}>
      <GlobalDialog
        title={activeConfig?.title}
        open={Boolean(modalState?.actionKey)}
        setOpen={(val) => {
          if (!val) setModalState({ actionKey: '', row: null });
        }}
        closeButton={true}
        content={activeConfig?.render ? activeConfig.render({ row: modalState.row }) : null}
        maxWidth={activeConfig?.maxWidth || 'md'}
        fullWidth={true}
      />
      <Stack gap={1}>
        <Box display={'flex'} gap={1} flexDirection={{ xs: 'column', sm: 'row' }}>
          <Autocomplete
            options={isCrm ? croList : crosunderproject}
            getOptionLabel={(e) => e.name}
            isOptionEqualToValue={(opt, val) => opt.userID === val.userID}
            onChange={(e, v) => {
              setCro(v);
            }}
            sx={{ width: { xs: '100%', sm: 230 } }}
            renderInput={(params) => <TextField {...params} label="CRO Name" />}
          />
          <FromAndToDatePicker fromDate={fromDate} setFromDate={setFromDate} toDate={toDate} setToDate={setToDate} />
        </Box>
        <GlobalTable
          rowUniqueId="sl_no"
          headers={studentClassRestartDateHeader}
          rows={studentClassRestartDateTable}
          tableState={tableState}
          setTableState={setTableState}
          loading={loading}
          onButtonActionClick={handleButtonActionClick}
          meta={meta}
        />
      </Stack>
    </GlobalWrapper>
  );
}
